export default "__VITE_ASSET__9qqXfOjO__"